import React from "react";
import { AnnouncementsModal } from "components/modals";
//import SmsWelcomeModal from 'components/modals/SmsWelcomeModal'
import TrialEndModal from "components/modals/TrialEndModal";
import { Footer, PageWrapper } from "components/navbars";
import { RecaptchaProvider } from "components/recaptcha";
import ErrorBoundary from "components/routing/ErrorBoundary";
import Toaster from "components/shared/Toaster";
import MessageEditor from "components/virtual/messageEditor";
import CreateBrandProfileModal from "containers/login/create-brand-profile/CreateBrandProfileModal";
import NavBar, { ImpersonatingMarker } from "containers/navbars";
import ReducersLoaderOptional from "containers/ReduceLoadersOptional";
import ReducersLoader from "containers/ReducersLoader";
import Routes from "containers/Routes";
import UpdatedTermsModal from "containers/terms";
import GlobalContext from "contexts";
import { ToasterProvider } from "contexts/ToasterContext";
import GlobalTheme from "GlobalTheme";
import useDebug from "hooks/useDebug";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import initAnalytics, { GoogleAnalytics } from "utils/analytics";
import history from "utils/getHistory";
// import initAxios from "utils/initAxios";
import store from "utils/reduxStore";
//import ProximaInfoModal from 'components/modals/ProximaInfoModal'
import initDataDog from "./utils/datadog";

const BASENAME = "/app";
const supportsHistory = "pushState" in window.history;

const isPublicPath = [
  "/about-us",
  // '/meet-the-team', // TODO: Disabled as of 11/30/2021
  "/apply",
  "/login",
  "/register-solo",
  "/register",
  "/forgot-password",
  "/update-password",
  "/add-brand",
  "/pricing",
  "/shopify/all-set",
].includes(history.location.pathname);

// Some routes could have a session (logged in) or not (public route)
const sessionOptional = ["/shopify/oauth"].includes(history.location.pathname);

// initAxios();
initAnalytics();
initDataDog();

export default function App() {
  useDebug();

  if (sessionOptional) {
    return (
      <Provider store={store}>
        <Router basename={BASENAME} forceRefresh={!supportsHistory} history={history}>
          <RecaptchaProvider>
            <GlobalTheme>
              <GlobalContext>
                <ReducersLoaderOptional>
                  <PageWrapper>
                    <ErrorBoundary>
                      <Routes />
                    </ErrorBoundary>
                    <ImpersonatingMarker />
                    <Toaster />
                  </PageWrapper>
                </ReducersLoaderOptional>
              </GlobalContext>
            </GlobalTheme>
          </RecaptchaProvider>
        </Router>
      </Provider>
    );
  }

  // Public pages only
  if (isPublicPath) {
    return (
      <Provider store={store}>
        <Router basename={BASENAME} forceRefresh={!supportsHistory} history={history}>
          <RecaptchaProvider>
            <GlobalTheme>
              <ToasterProvider>
                <ErrorBoundary>
                  <Routes />
                </ErrorBoundary>
                <Toaster />
              </ToasterProvider>
            </GlobalTheme>
          </RecaptchaProvider>
        </Router>
      </Provider>
    );
  }

  // Pages that are not public and require a session
  return (
    <Provider store={store}>
      <Router basename={BASENAME} forceRefresh={!supportsHistory} history={history}>
        <RecaptchaProvider>
          <GlobalTheme>
            <GlobalContext>
              <ReducersLoader>
                <GoogleAnalytics />
                <PageWrapper>
                  <NavBar />
                  <ErrorBoundary>
                    <Routes />
                  </ErrorBoundary>
                  <ImpersonatingMarker />
                  <CreateBrandProfileModal />
                  <AnnouncementsModal />
                  <UpdatedTermsModal />
                  <TrialEndModal />
                  <Toaster />
                  <MessageEditor />
                </PageWrapper>
                <Footer />
              </ReducersLoader>
            </GlobalContext>
          </GlobalTheme>
        </RecaptchaProvider>
      </Router>
    </Provider>
  );
}
